import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'reply';

export const replyActions = createTypes([
    'addPost',
    'removePost',
    'likePost',
], namespace);

export const replyActionsCreators = {
    addPost: fromType(replyActions.addPost, ['reply', 'discussionId']),
    removePost: fromType(replyActions.removePost, ['id']),
    likePost: fromType(replyActions.likePost, ['id', 'isLiked']),
}